import { render, staticRenderFns } from "./ServiceFieldsEditor.vue?vue&type=template&id=ef1984de"
import script from "./ServiceFieldsEditor.vue?vue&type=script&lang=js"
export * from "./ServiceFieldsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports